import React, { useState } from 'react';
import { Box, Modal, TextField } from '@mui/material';
import { boxStyle } from './styles';

interface IProps {
    open: boolean;
    onClose: () => void;
    label: string;
    initialHours: number;
    onSave: (hours: number) => void;
    accentColor: string;
}

const ProjectExtrasModal = (props: IProps) => {
    const [hours, setHours] = useState<string>(props.initialHours > 0 ? String(props.initialHours) : '');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        props.onSave(parseFloat(hours) || 0);
        props.onClose();
    };

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <Box style={boxStyle}>
                <form
                    onSubmit={handleSubmit}
                    className='flex flex-col items-center gap-4'
                >
                    <div style={{
                        fontSize: '16px',
                        fontWeight: 700,
                        color: props.accentColor,
                        alignSelf: 'flex-start',
                    }}>
                        {props.label}
                    </div>
                    <TextField
                        type='number'
                        label='Uren'
                        value={hours}
                        inputProps={{ min: 0, step: 0.25 }}
                        onChange={(e) => setHours(e.target.value)}
                        autoFocus
                        style={{ width: '220px' }}
                    />
                    <button style={{ width: '220px' }}>Opslaan</button>
                </form>
            </Box>
        </Modal>
    );
};

export default ProjectExtrasModal;
